
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/savePublish/panels/save/feedbackPanel/feedbackPanel.scss.css.virtualfile';
        module.exports = {"modal":"_modal_mmb9m_1","content":"_content_mmb9m_4","rating":"_rating_mmb9m_7","textarea":"_textarea_mmb9m_10"};